export const ERROR_DEFAULT = "An error happened";
